import { PATHS } from '@belong/common';
import { Modal, Text, Button, LinkBase } from '@belong/ui';
import clsx from 'clsx';

export function HomeAlreadyExistsModal({
  isOpen,
  onDismiss,
  onCtaClick,
  ctaText,
}: Props): JSX.Element {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} name="home_already_exists">
      <div
        className={clsx(
          'pt-2xl flex w-full flex-col items-center overflow-hidden rounded',
        )}
      >
        <Text
          variant="h2"
          fontWeight="semibold"
          className="px-xl text-center"
        >{`Looks like this beautiful home is part of Belong's Network!`}</Text>
        {/* TODO: Extract bottom bar */}
        <div className="mt-sm px-2sm md:mt-xl md:border-dark-gray md:bg-light-gray md:p-md w-full md:flex md:justify-between md:border-0 md:border-t md:border-solid">
          <div className="mb-sm flex items-center justify-center md:mb-0 md:justify-start">
            <Text className="mr-xs md:mr-sm">Questions or concerns?</Text>
            <LinkBase href={PATHS.SUPPORT}>
              <Text
                fontWeight="semibold"
                className="uppercase"
              >{`Let's Talk`}</Text>
            </LinkBase>
          </div>
          <div>
            <Button onClick={onCtaClick}>{ctaText}</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  ctaText: string;
  onCtaClick: () => void;
};
